import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo3_Maria } from '../../../../../utils/EN/Modals/directors';

const ModalVideoMaria3 = () => {
  return (
    <>
      <ModalVideo
        id="maria-video-3"
        dataText={TextVideo3_Maria}
        videoSrc="https://player.vimeo.com/video/1032490114?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_MARIA_3"
      />
    </>
  );
};

export default ModalVideoMaria3;
